import { Component, Input, OnInit } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { AllStatistics, StatsType } from 'src/app/models/statistics.model';

@Component({
  selector: 'app-statistics-card',
  templateUrl: './statistics-card.component.html',
  styleUrls: ['./statistics-card.component.scss'],
})
export class StatisticsCardComponent implements OnInit {
  @Input() statsSVG!: SafeHtml;
  @Input() statsType!: StatsType;
  @Input() allStatistics!: AllStatistics;

  constructor() {}

  ngOnInit() {
  }
}
